<template>
  <el-form label-position="top" :model="form" ref="form_create">
    <el-form-item
      style="margin-top: 30px; font-weight: bold"
      label="Nombre del archivo"
      :prop="folderName"
    >
      <el-input
        v-model="folderName"
        placeholder="Escribir el nombre del archivo"
        class="fields"
      ></el-input>
    </el-form-item>

    <el-form-item label="Adjuntar documento" style="font-weight: bold">
      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :file-list="fileList"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-error="handleError"
        :on-preview="handlePreview"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          Solo archivos con un tamaño menor de 4MG
        </div>
      </el-upload>
    </el-form-item>
    <el-button @click="onCancel" size="mini">Cancel</el-button>
    <el-button id="btnSave" type="primary" size="mini" @click="saveDocument"
      >Guardar</el-button
    >
  </el-form>
</template>
<script>
export default {
  name: "magycorpSaCreateD",
  props: {
    Visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEnabled: true,
      fileList: [],
      folderName: "",
      form: {
        folderName: "",
        //  AttachmentUrl: this.fileList.Name,
        CreatedBy: this.$store.state.user.user.UserID,
        CompanyCode: this.$store.state.user.user.CompanySelected,
        fileListResponse: []
      },
      rules: {
        folderName: [{ required: true, trigger: "blur", message: "Requerido" }]
      },
      categoriesValue: [],
      count: 0
    };
  },

  computed: {
    totalUploadFiles() {
      return this.$refs.uploadFile.uploadFiles.length;
    }
  },
  methods: {
    onCancel() {
      this.fileList = [];
      //this.$refs.uploadFile.uploadFiles = [];
      this.form = {};
      this.$emit("dialog-closed");
      this.$refs.form_create.resetFields();
    },
    saveDocument() {
      this.$refs.form_create.validate((valid) => {
        if (valid) {
          this.$refs.uploadFile.submit();
        } else {
          return false;
        }
      });
    },
    handleUploadOnSuccess(response) {
      this.isEnabled = false;
      const items_count = response.length;
      for (var index = 0; index < items_count; index++) {
        if (items_count > 0) {
          this.fileList.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
      }
      //this.$refs.uploadFile.uploadFiles = [];
      this.count++;
      this.saves();
    },
    handleError(/*err, file, fileList*/) {
      //console.log(err, file, fileList);
    },
    saves() {
      let self = this;
      self.fileList.forEach((listFiles) => {
        if (this.count === this.totalUploadFiles) {
          self.form.fileListResponse = self.fileList;
          var params = {
            AttachmentUrl: listFiles.url,
            modulo: "Magycorp_Technologies_srl.",
            AttachmentFileName: listFiles.name,
            CompanyCode: this.$store.state.user.user.CompanySelected,
            moduleId: 8,
            folderName: this.folderName,
            CreatedBy: this.$store.state.user.user.UserID
          };
          self.$http
            .post("/api/Folder/AddDocumentDevelopment", params)
            .then(() => {
              self.$emit("dialog-closed");
              self.$message({
                type: "success",
                message: "Archivo Agregado correctamente"
              });

              self.$emit("success");
            })
            .catch((err) => {
              self.$message({ type: "error", message: err.message });
              console.log("error");
            })
            .finally(() => {
              // self.count = 0;
              self.form = {};
              self.folderName = "";
              self.fileList = [];
              self.$refs.form_create.resetFields();
            });
        }
      });
    }
  },
  watch: {
    Visible(val) {
      this.form = {};
      if (!val) this.fileList = []; //this.$refs.uploadFile.uploadFiles = [];
    },

    folderName() {
      this.saveDocument();
    }
  }
};
</script>
<style scoped>
.title {
  /* Nuevo Documento */

  position: absolute;
  width: 143px;
  height: 19px;
  left: 20px;
  top: 52px;

  margin-left: 35%;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  color: #2484c4;
}

label .el-form-item__label {
  /* Adjuntar documento */

  width: 188px;
  height: 18px;

  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;

  color: #3c3c3c;
}

label {
  color: #bf3636;
  margin-top: 5px;
  margin-bottom: 5px;
}
ul > li > label > .el-upload-list--picture .el-upload-list__item-status-label {
  position: absolute;
  right: -17px;
  top: -7px;
  width: 46px;
  height: 26px;
  background: #5f8fdf;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 1px 1px #ccc;
}
</style>
